export default __webpack_public_path__ + "static/media/clock_icon.6cd31606.svg";